import { type Account } from '@air/api';

export type GetIdFromSSOOptionsParams = Extract<
  Awaited<ReturnType<typeof Account.getAccountSSOOptionsV2>>,
  // biome-ignore lint/suspicious/noExplicitAny: <Data from SSO options can be anything>
  { data: any }
>['data'][number];

export const getIdFromSSOOptions = (ssoOptions: GetIdFromSSOOptionsParams) => {
  return 'organizationId' in ssoOptions ? ssoOptions.organizationId : ssoOptions.workspaceId;
};
